import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SystemBanner } from '../../../../models/shared/system-banner';
import { SystemBannerIconPipe } from './system-banner-icon.pipe';
import { SystemBannerDismissIconPipe } from './system-banner-dismiss-icon.pipe';

@Component({
  selector: 'app-system-banner',
  standalone: true,
  imports: [CommonModule, SystemBannerIconPipe, SystemBannerDismissIconPipe],
  templateUrl: './system-banner.component.html',
  styleUrls: ['./system-banner.component.scss']
})
export class SystemBannerComponent {
  @Input() banner!: SystemBanner;
  @Input() dismissIconSrc: string = 'assets/icons/blue/X.svg';
  @Output() dismissBannerClicked = new EventEmitter<void>();
  @Output() textButtonClicked = new EventEmitter<void>();
}
